import SearchBaseComponent from './searchBaseComponent';

export default SearchBaseComponent;
